import type { ZeroviaClient } from "@agentry/api-client";

/** B160 User Attribute。サブドメインLP経由の登録で書き込む。 */
export const SYS_AGENT_FILTER_LIST = "SYS_AGENT_FILTER_LIST";

/**
 * 属性値（サイトID）→ 表示する UCS ID。
 *
 * ここに無い値、空文字、属性そのものが無い場合は Agent 一覧を全件表示する。
 * リスト内の ID がカタログに1件も無い場合も全件表示（指定値以外と同じ扱い）。
 */
export const SITE_AGENT_FILTER_LISTS: Record<string, readonly string[]> = {
	lp: ["UCS-WEB-001-02-v1", "UCS-WEB-010-01-v1", "UCS-WEB-020-01-v1"],
	newbiz: ["UCS-CMN-002-01-v1"],
	creator: ["UCS-WEB-001-02-v1"],
};

const TOKEN_SPLIT = /[,;\s]+/;

export function agentFilterAttributesForValue(
	value: string | undefined,
): Record<string, string> | undefined {
	if (!value) return undefined;
	return { [SYS_AGENT_FILTER_LIST]: value };
}

export function agentFilterAttributesForSite(
	siteId: string,
): Record<string, string> | undefined {
	if (!Object.hasOwn(SITE_AGENT_FILTER_LISTS, siteId)) return undefined;
	return agentFilterAttributesForValue(siteId);
}

export function filterUcsByAgentFilterList<T extends { id: string }>(
	ucs: readonly T[],
	rawValue: string | null | undefined,
	lists: Record<string, readonly string[]> = SITE_AGENT_FILTER_LISTS,
): T[] {
	if (rawValue == null) return [...ucs];
	const trimmed = rawValue.trim();
	if (trimmed === "") return [...ucs];

	const allowed = new Set<string>();
	for (const token of trimmed.split(TOKEN_SPLIT).filter(Boolean)) {
		const mapped = lists[token];
		if (mapped) {
			for (const id of mapped) allowed.add(id);
		} else {
			allowed.add(token);
		}
	}

	const matched = ucs.filter((item) => allowed.has(item.id));
	return matched.length > 0 ? matched : [...ucs];
}

export async function readAgentFilterValue(
	client: Pick<ZeroviaClient, "getUserAttributes">,
	userId: string,
): Promise<string | undefined> {
	try {
		const map = await client.getUserAttributes(userId);
		return map.items.find((item) => item.key === SYS_AGENT_FILTER_LIST)?.value;
	} catch {
		return undefined;
	}
}
